import React, { useEffect, useState } from 'react';

import useVisibilityObserver from '@storefront/hooks/useVisibilityObserver';

import { sendAnalytics, SendAnalyticsProps } from './SimpleTriggerEvent';

export interface SingleTriggerVisibleEventProps extends SendAnalyticsProps {
  elementId: string;
  treshold: number;
}

const SingleTriggerVisibleEvent = <P extends SingleTriggerVisibleEventProps>(
  WrappedComponent: React.FC<P>
): React.FC<any> => {
  function CommonLogicComponent(props: Readonly<P>) {
    const [eventSent, setEventSent] = useState(false);
    const {
      elementId,
      treshold,
      simpleUiEvent,
      override = {},
      additionalInformation = {},
    } = props;

    const isElementVisible = useVisibilityObserver(
      elementId,
      treshold
    )?.isVisible;

    useEffect(() => {
      if (isElementVisible && !eventSent) {
        sendAnalytics({
          simpleUiEvent: simpleUiEvent,
          override: override,
          additionalInformation: additionalInformation,
        });
        setEventSent(true);
      }
    }, [isElementVisible]);
    return <WrappedComponent {...props} />;
  }
  return CommonLogicComponent;
};

export default SingleTriggerVisibleEvent;
